import script from "./HomeTechnologies.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeTechnologies.vue?vue&type=script&lang=ts&setup=true"

import "./HomeTechnologies.vue?vue&type=style&index=0&id=6b7c256a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7c256a"]])

export default __exports__